import { useState } from 'react';
import { Box } from '@alf/uikit';
import { FilterCard } from './FilterCard';
import { GamesSearchFilterDrawer } from './GamesSearchFilterDrawer';

import styles from './index.module.css';

export const FilterCardWithDrawer = ({
  filterBodyTextKey,
  cardTitleTextKey,
  filterId,
  children,
  onResetClick,
  onApplyClick,
  onDrawerCloseClick,
  selectedQuantity = 0,
  isLoading,
  wasFilterChanged,
  isFilterFilled
}) => {
  const [isDrawerOpened, setIsDrawerOpened] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpened((prev) => !prev);
  };

  if (isLoading) {
    return <Box className={styles.filterCardSkeleton} />;
  }

  return (
    <>
      <GamesSearchFilterDrawer
        filterId={filterId}
        onResetClick={onResetClick}
        onApplyClick={onApplyClick}
        onDrawerCloseClick={onDrawerCloseClick}
        titleTextKey={cardTitleTextKey}
        filterBodyTextKey={filterBodyTextKey}
        toggleDrawer={toggleDrawer}
        wasFilterChanged={wasFilterChanged}
        isFilterFilled={isFilterFilled}
        isOpen={isDrawerOpened}
      >
        {children}
      </GamesSearchFilterDrawer>
      <FilterCard
        toggleDrawer={toggleDrawer}
        selectedQuantity={selectedQuantity}
        cardTitleTextKey={cardTitleTextKey}
      />
    </>
  );
};
